import { Membership } from '@models';

export interface MembershipHistoryResult {
  membershipHistory: Membership[];
}
